import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { CatalogDataProvider } from './CatalogDataContext';
import Catalog from './Catalog';
import CollectionDetail from './CollectionDetail';
import BoardDetail from './BoardDetail';

const CatalogRouter = ({ match }) => {
  const { path } = match;

  return (
    <CatalogDataProvider>
      <Switch>
        <Route exact path={path} component={Catalog} />
        <Route path={`${path}/collections/:collectionId`} component={CollectionDetail} />
        <Route path={`${path}/boards/:boardId`} component={BoardDetail} />
      </Switch>
    </CatalogDataProvider>
  );
};

export default CatalogRouter;
